import type { ActionInput, ActionOutput, OsFamily } from '@occ/contracts';
import { runAction } from './actions';

/**
 * Ejecución de scripts (Módulo 6.1).
 *
 * `script.run` del catálogo es **petición y respuesta**: devuelve `stdout`,
 * `stderr`, el código de salida y si hubo truncado, todo junto al terminar. No
 * hay salida incremental porque el contrato no la modela — para eso habría que
 * añadir al catálogo una variante que abra un stream, como hace `terminal.open`.
 * La pantalla lo dice en vez de simular un avance que no existe: mientras corre
 * enseña el tiempo transcurrido, que es información real.
 */

export type ScriptShell = Extract<ActionInput<'script.run'>['script'], { inline: string }>['shell'];
export type ScriptResult = ActionOutput<'script.run'>;

export const SHELLS: Array<{ value: ScriptShell; label: string }> = [
  { value: 'powershell', label: 'PowerShell' },
  { value: 'bash', label: 'bash' },
  { value: 'sh', label: 'sh' },
];

/** Intérprete que tiene sentido por defecto según el sistema que reportó el nodo. */
export const defaultShellFor = (osFamily: OsFamily | null | undefined): ScriptShell =>
  osFamily === 'windows' ? 'powershell' : 'bash';

export const DEFAULT_TIMEOUT_SECONDS = 120;

export const runScript = (
  nodeId: string,
  inline: string,
  shell: ScriptShell,
  timeoutSeconds: number,
): Promise<ScriptResult> =>
  runAction('script.run', {
    node: { nodeId },
    script: { inline, shell },
    timeoutSeconds,
  });
